export default "__VITE_ASSET__9aqIZJbu__"